import { createAction } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { LaunchConfigurationsDTO } from "./models/dto";

export namespace LaunchConfigurationsActions {
  export enum ActionTypes {
    setLaunchConfigurations = "LaunchConfigurations: Set Launch Configurations",
    setPagination = "LaunchConfigurations: Set Pagination",
    resetLaunchConfigurations = "LaunchConfigurations: Reset Launch Configurations",
    getSingleLaunchConfiguration = "LaunchConfigurations: Get Single Launch Configuration",
    setSingleLaunchConfiguration = "LaunchConfigurations: Set Single Launch Configuration",

    setNewLaunchConfigurationSection = "LaunchConfigurations: Set New Launch Configuration Section",
    resetAllNewLaunchConfigurationSection = "LaunchConfigurations: Reset All New Launch Configuration Section",
  }

  // Actions Types

  export const resetLaunchConfigurations = createAction(
    ActionTypes.resetLaunchConfigurations
  );

  export const setLaunchConfigurations = createAction<
    | FetchableSuccess<LaunchConfigurationsDTO.Responses.GetAll.T>
    | FetchableError,
    ActionTypes.setLaunchConfigurations
  >(ActionTypes.setLaunchConfigurations);

  export const getSingleLaunchConfiguration = createAction<
    LaunchConfigurationsDTO.Responses.GetSingle.T["id"],
    ActionTypes.getSingleLaunchConfiguration
  >(ActionTypes.getSingleLaunchConfiguration);

  export const setSingleLaunchConfiguration = createAction<
    { id: string; result: LaunchConfigurationsDTO.Responses.GetSingle.T },
    ActionTypes.setSingleLaunchConfiguration
  >(ActionTypes.setSingleLaunchConfiguration);

  export const setPagination = createAction<
    Pageable.T<keyof LaunchConfigurationsDTO.Responses.GetSingle.T>,
    ActionTypes.setPagination
  >(ActionTypes.setPagination);

  export const setNewLaunchConfigurationSection = createAction<
    Partial<LaunchConfigurationsDTO.Requests.SetSingle.T>,
    ActionTypes.setNewLaunchConfigurationSection
  >(ActionTypes.setNewLaunchConfigurationSection);

  export const resetAllNewLaunchConfigurationSection = createAction(
    ActionTypes.resetAllNewLaunchConfigurationSection
  );

  export type ResetLaunchConfigurations = ReturnType<
    typeof resetLaunchConfigurations
  >;
  export type SetLaunchConfigurations = ReturnType<
    typeof setLaunchConfigurations
  >;
  export type SetSingleLaunchConfiguration = ReturnType<
    typeof setSingleLaunchConfiguration
  >;
  export type GetSingleLaunchConfiguration = ReturnType<
    typeof getSingleLaunchConfiguration
  >;
  export type SetPagination = ReturnType<typeof setPagination>;

  export type SetNewLaunchConfigurationSection = ReturnType<
    typeof setNewLaunchConfigurationSection
  >;
  export type ResetAllNewLaunchConfigurationSection = ReturnType<
    typeof resetAllNewLaunchConfigurationSection
  >;

  export type Actions =
    | SetLaunchConfigurations
    | ResetLaunchConfigurations
    | SetPagination
    | SetSingleLaunchConfiguration
    | GetSingleLaunchConfiguration
    | SetNewLaunchConfigurationSection
    | ResetAllNewLaunchConfigurationSection;
}
